import React from "react";
import { useSelector } from "react-redux";

// Components
import MDCButton from "../../core/MDCButton";

// Material UI
import Grid from "@mui/material/Grid";

// Constants
import { USER_ROLE_APPROVER } from "../../../constants/userConstants";
import DuplicateFilterIcon from "../../iconComponents/DuplicateFilterIcon";

const VollmachtAbbrechen = ({ handleModal }) => {
  const userDetails = useSelector((state) => state?.authentication?.user);

  const isAdminAndSupportUser =
    !userDetails?.roles?.includes(USER_ROLE_APPROVER);

  return (
    <Grid container>
      <Grid marginLeft="auto" marginBottom="2%">
        <MDCButton
          variant="warningOutlined"
          label={"Vollmachtsprozess abbrechen"}
          onClick={handleModal}
          disabled={isAdminAndSupportUser}
          endIcon={<DuplicateFilterIcon color="#000" />}
        />
      </Grid>
    </Grid>
  );
};

export default VollmachtAbbrechen;
